import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

const usdFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatUsdCurrency(value: number) {
  return usdFormatter.format(value)
}
